import axios from "axios";

const BASE_URL = "https://online.funforay.com/admin/public/api";

export const registerUser = async (userData) => {
  return axios.post(`${BASE_URL}/register`, userData);
};

export const loginUser = async (loginData) => {
  return axios.post(`${BASE_URL}/login`, loginData);
};

export const getUserProfile = async () => {
  return axios.get(`${BASE_URL}/profile`);
};
